module.exports = __webpack_public_path__ + "img/amazon_transportes.62297e10.svg";